import React, { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { createDataDogBrowserRouter, ErrorBoundary } from '@economic/react-app';
import { createRoot } from 'react-dom/client';

const External = React.lazy(() => import('./external'));
const Host = React.lazy(() => import('./components/Host'));

const router = createDataDogBrowserRouter([
    { path: '/external/*', Component: External },
    { path: '*', Component: Host },
]);

const Router = () => {
    return <RouterProvider router={router} />;
};

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <Suspense>
                <Router />
            </Suspense>
        </ErrorBoundary>
    </React.StrictMode>
);

const params = new URLSearchParams(window.location.search);
const clientVersion = params.get('_x_client_version');

if (clientVersion) {
    import('./utilities/clientVersion').then(({ reportClientVersion }) => {
        reportClientVersion(clientVersion);
    });
}
